<app-loader [Parent]="this"></app-loader>
@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
      <form-edit-button>Edit</form-edit-button>
      <app-form-delete-button [Parent]="this" [Model]="Model" DeleteUrl="permits/hotelreservationpermittypes/" [DeleteCheck]="false" Api="permits"
      TypeName="HotelReservationParkingPermitType" DeleteNavLink="/permits/hotelreservationpermittypes"></app-form-delete-button>
    </app-pageheader>
    <div class="columns">
      <div class="column is-8">
        <article class="panel">
          <p class="panel-heading">
            Hotel Group Details
          </p>
          <div class="panel-block">
            <span class="label">Name</span>
            <span class="value">{{Model.Name}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Active Dates</span>
            <span class="value">
              <app-daterangedisplay FieldName="Active Dates" [StartDate]="Model.ActiveStartDateLocalFriendlyString" [EndDate]="Model.ActiveEndDateLocalFriendlyString"></app-daterangedisplay>
            </span>
          </div>
          <div class="panel-block">
            <span class="label">Max Active Guests</span>
            <span class="value">{{Model.MaxActivePermits ?? 'No Limit'}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Cutoff Time</span>
            <span class="value">{{Model.CutoffTimeLocalFriendlyString}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Price</span>
            <span class="value">{{Model.PriceString}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Unique Code</span>
            <span class="value">{{Model.UniqueCode || 'None'}}</span>
          </div>
        </article>
      </div>
      </div>
      <div class="columns">
      <div class="column is-8">
        <article class="panel">
          <p class="panel-heading">
            Group Instances
          </p>
          <div class="panel-block">
            <app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="permits/hotelreservations/type/{{Model.Id}}" [AllowEdit]="false"></app-datalistview>
          </div>
        </article>
      </div>
    </div>
  </div>
}


